import React, { useState } from 'react';
import storage from '../../../../../../player/js/storage';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { usePlayerContext } from '../../../../context/PlayerContext';
import { useEventContext } from '../../../../context/EventContext';
import { unixFormat } from '../../../../helpers/times';
import { EPISODE_STATUSES } from '../../../../constants/common';
import Status from '../../../Schedule/ScheduleComponents/ScheduleEpisodeStatus';
import Icons from '../../../Icons';
import { CButton } from '../../../UI';

import './style.scss';

export const expandedStyle = {
    width: 'max-content',
    minWidth: 140,
    maxWidth: 400,
    backdropFilter: 'blur(4px)',
    zIndex: 100
};


export default ({
    stream,
    episode,
    className,
    pageType,
    style,
    onClick = undefined,
    handleBookmark,
    bookmarkEpisodeIds = [],
    isBookmarkVisible = true,
    currentUser,
    checkAuth,
    onRateEpisode,
    onMouseEnter = () => {},
}) => {
    const $locale = useLocaleContext();
    const playerContext = usePlayerContext();
    const { eventKey } = useEventContext();
    const ratedStorageKey = `${eventKey}/episodes/rated`;
    const ratedEpisodes = storage.get(ratedStorageKey) || {};
    const currentUserId = currentUser?.clientRegistrationId ?? currentUser?.id;
    const [isRated, setIsRated] = useState(ratedEpisodes[episode.id]?.includes(currentUserId));

    const [episodeStatus, setEpisodeStatus] = useState(null);
    const [expanded, setExpanded] = useState(false);

    const onBookmark = (e) => {
        e.stopPropagation();
        handleBookmark(episode.id);
    }

    const isBookmark = bookmarkEpisodeIds.includes(episode.id);

    const handleRateToggle = async (e) => {
        e.stopPropagation();

        const isAuth = await checkAuth(currentUser);
        if (isAuth) {
            setIsRated(isRated => !isRated);
            const value = !isRated;
            const ratedEpisodes = storage.get(ratedStorageKey) || {};
            const arr = ratedEpisodes[episode.id] || [];
            const ratedStorageValue = { ...ratedEpisodes, [episode.id]: value ? [...arr, currentUserId] : arr.filter(id => id !== currentUserId) };
            onRateEpisode(ratedStorageKey, episode.id, value, ratedStorageValue);
        }
    }

    const handleCardMouseEnter = (e) => {
        const _expanded = style.width < 120;
        setExpanded(_expanded);
        if (e) {
            onMouseEnter(e.currentTarget, _expanded);
        }
    };

    const additionalStyle = expanded ? expandedStyle : {};

    return (
        <div
            className={`
                broadcast-episode
                broadcast-episode--${episodeStatus}
                ${playerContext?.currentEpisode?.id === episode.id ? 'broadcast-episode--current' : ''}
                ${className}
            `}
            style={{
                ...style,
                ...additionalStyle,
                '--stream-color': `${stream.color}`,
            }}
            onClick={() => onClick({ episodeStatus, ...episode })}
            onMouseEnter={handleCardMouseEnter}
            onMouseLeave={() => setExpanded(false)}
        >
            <div className="broadcast-episode-wrapper">
                <div className="broadcast-episode-header">
                    <div className="broadcast-episode-header__time">
                        <span>{unixFormat(episode.timeStart, 'HH:mm')} —</span> <span>{unixFormat(episode.timeStop, 'HH:mm')}</span>
                    </div>
                    {
                        isBookmarkVisible &&
                        <div className={`broadcast-episode-header__bookmark ${isBookmark ? '-is-bookmark' : ''}`}>
                            <CButton
                                icon="bookmark"
                                blank
                                className="broadcast-episode-bookmark"
                                onClick={onBookmark}
                            />
                        </div>
                    }
                    <div className="broadcast-episode-header__status">
                        <Status
                            timeStart={episode.timeStart}
                            timeStop={episode.timeStop}
                            altStatuses={pageType === 'broadcast'}
                            onStatusUpdate={setEpisodeStatus}
                        />
                    </div>
                </div>
                <div className="broadcast-episode-name">
                    {
                        ((pageType === 'broadcast' || playerContext.isShowPlayerHalls) && stream.dvr && episodeStatus === EPISODE_STATUSES.record) &&
                        <span className="broadcast-episode-play">
                            <Icons name="play" />
                        </span>
                    }
                    <div
                        className="broadcast-episode-name__title"
                        style={(style.width < 150 && !expanded) ? { whiteSpace: 'nowrap', display: 'inline' } : {}}
                    >
                        {$locale.getProperty(episode, 'name')}
                    </div>
                </div>
                <div className="broadcast-episode-footer">
                    {onRateEpisode && (
                        <a onClick={handleRateToggle} className={`broadcast-episode-like ${isRated ? '-active' : ''}`}>
                            <Icons name="like_message" active={isRated} />{episode.like}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};
